<app-modal-filler-atom
  (click)="close()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed right-0 left-0 shadow overflow-y-auto mdMax:bottom-0 mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:mx-auto md:flex md:justify-center md:items-center md:w-full md:h-full md:top-0 md:left-0"
  [style.z-index]="(index$ | async) + 50"
>
  <app-modal-filler-atom
    *ngIf="isDesktop$ | async"
    [withBackdrop]="false"
    (click)="close()"
    [index]="index$ | async"
  ></app-modal-filler-atom>
  <div
    class="md:min-w-448 bg-white p-5 md:p-7 rounded-t-3xl md:rounded-3xl md:max-w-lg md:w-2/5"
    [style.z-index]="(index$ | async) + 50"
  >
    <h1
      class="text-neutral-800 font-brand font-bold text-28px pb-5"
      translate="zerosix.link-account.header"
    ></h1>
    <ng-container *ngIf="step === 'link-form' || step === 'verification-code'">
      <form [formGroup]="form">
        <div class="relative pb-6">
          <ng-container *ngIf="step === 'link-form'">
            <label
              for="phone"
              class="block mb-1 text-sm leading-5 font-base font-normal text-neutral-600"
              translate="signup.phone"
            ></label>
            <label
              for="phone"
              class="block mb-2 text-xs font-base font-normal text-neutral-500"
            >
              {{ 'zerosix.help-phone-format' | translate }}
            </label>
            <input
              id="phone"
              type="tel"
              formControlName="phone"
              (keyup.enter)="onSubmit()"
              class="flex w-full py-8xs px-5 bg-neutral-50 text-base font-base font-normal leading-5 border border-solid border-neutral-300"
              [class.border-error-700]="
                phoneErrorMessage ||
                (form.controls?.phone?.errors &&
                  (form.controls?.phone?.dirty || form.controls?.phone?.touched))
              "
            />
            <ng-container
              *ngIf="
                form.controls?.phone?.invalid &&
                (form.controls?.phone?.dirty || form.controls?.phone?.touched)
              "
            >
              <span
                class="block absolute bottom-1 text-xs font-base font-normal text-error-700"
                *ngIf="form.controls?.phone?.errors"
                translate="signup.invalid-phone"
              ></span>
            </ng-container>
            <ng-container *ngIf="phoneErrorMessage">
              <span
                class="text-xs font-base font-normal text-error-700"
                [translate]="phoneErrorMessage"
              ></span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="step === 'verification-code'">
            <label
              for="authCode"
              class="block mb-1 text-sm leading-5 font-base font-normal text-neutral-600"
              translate="zerosix.link-account.enter-auth-code"
            ></label>
            <input
              id="authCode"
              type="text"
              formControlName="authCode"
              (keyup.enter)="onSubmit()"
              class="flex w-full py-8xs px-5 bg-neutral-50 text-base font-base font-normal leading-5 border border-solid border-neutral-300"
              [class.border-error-700]="
                authCodeErrorMessage ||
                (form.controls?.authCode?.errors &&
                  (form.controls?.authCode?.dirty || form.controls?.authCode?.touched))
              "
            />
            <ng-container
              *ngIf="
                form.controls?.authCode?.invalid &&
                (form.controls?.authCode?.dirty || form.controls?.authCode?.touched)
              "
            >
              <span
                class="block absolute bottom-1 text-xs font-base font-normal text-error-700"
                *ngIf="form.controls?.authCode?.errors"
                translate="zerosix.link-account.errors.invalid-auth-code"
              ></span>
            </ng-container>
            <ng-container *ngIf="authCodeErrorMessage">
              <span
                class="text-xs font-base font-normal text-error-700"
                [translate]="authCodeErrorMessage"
              ></span>
            </ng-container>
          </ng-container>
          <div
            class="self-center"
            *ngIf="errorMessage"
          >
            <span
              class="text-xs font-base font-normal text-error-700"
              [translate]="errorMessage"
            ></span>
          </div>
        </div>
      </form>
      <div class="flex flex-col">
        <div
          class="pb-4"
          *ngIf="phoneErrorMessage === 'zerosix.link-account.errors.account-not-found'"
        >
          <app-button-atom
            size="M"
            [label]="'zerosix.link-account.create-new-account' | translate"
            (click)="openCreateLoyaltyAccountModal()"
            type="light"
            [full]="true"
          ></app-button-atom>
        </div>
        <div class="pt-1 flex xm:flex-nowrap gap-2">
          <div class="w-full xm:w-1/2">
            <app-button-atom
              size="M"
              [label]="'zerosix.cancel' | translate"
              (click)="close()"
              type="light"
              [full]="true"
            ></app-button-atom>
          </div>
          <div class="w-full xm:w-1/2">
            <app-button-atom
              [iconUrl]="isValidating ? 'assets/images/spinner.svg' : undefined"
              [disabled]="isValidating || this.form.invalid"
              size="M"
              [label]="'zerosix.validate' | translate"
              type="primary"
              [full]="true"
              (click)="onSubmit()"
            ></app-button-atom>
          </div>
        </div>
      </div>
    </ng-container>

    <div
      class="flex flex-col gap-10"
      *ngIf="step === 'confirmation'"
    >
      <p class="text-neutral-800 font-base text-base mb-0.5 flex items-center">
        <span><i class="icon icon-n-check text-success-600 text-xl mt-1 mr-1.5"></i></span>
        {{ 'zerosix.link-account.success-message' | translate }}
      </p>
      <app-button-atom
        size="L"
        [label]="'zerosix.validate' | translate"
        type="primary"
        [full]="true"
        (click)="close()"
      ></app-button-atom>
    </div>
  </div>
</div>
